import React, { useMemo } from "react";
import Filter from "./Filter";
import { FormField } from "../data/models";

interface DropdownFieldProps {
  field: FormField;
  value?: number | string; // trenutni ID
  onChange: (nextId: number | string | null) => void; // vrati ID ili null
  error?: boolean;
}

export default function DropdownField({
  field,
  value,
  onChange,
  error,
}: DropdownFieldProps) {
  const opts = field.options || [];

  const effectiveId = value ?? field.initialValue;

  // Lista labela
  const labelsList = useMemo(() => opts.map((o) => o.label), [opts]);

  // Trenutno selektirana labela
  const selectedLabel = useMemo(
    () => opts.find((o) => o.id === effectiveId)?.label,
    [opts, effectiveId]
  );

  // Mapiranje natrag iz labela u ID
  const handleFilterChange = (values: string[] | string) => {
    const label = Array.isArray(values) ? values[0] : values;
    const nextId = opts.find((o) => o.label === label)?.id ?? null;
    onChange(nextId);
  };

  return (
    <Filter
      name={field.placeholder}
      data={labelsList}
      selected={selectedLabel ? [selectedLabel] : []}
      onChange={handleFilterChange}
      multiple={false}
      error={error}
    />
  );
}
